import { api } from './apiClient.js';

/** POST /v1/tenant/file/create */
export const createFile = (body) => api.post('/v1/tenant/file/create', body);
